import Header from "../../../../components/header/Header";
import "./signin.scss";
import bgGradient from "../../../../images/bgrg.png";
import { Input, notification } from "antd";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { login } from "../../../../store/Auth";
import { setUser } from "../../../../store/User";
import { useDispatch } from "react-redux";

interface SigninFacilitatorProps {}

const SigninFacilitator: React.FunctionComponent<
  SigninFacilitatorProps
> = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const openErrorNotification = (text: string) => {
    notification.error({
      message: "Error",
      description: text,
    });
  };

  const signin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (email && password !== "") {
      setIsLoading(true);
      axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/users/login`,
        data: {
          email: email,
          password: password,
        },
      })
        .then((res) => {
          dispatch(login(res.data.data.token));
          dispatch(setUser(res.data.data));
          setIsLoading(false);
          res.data.data.user_type === 1
            ? navigate("/facilitator/dashboard")
            : res.data.data.user_type === 2
            ? navigate("/attendee/dashboard")
            : navigate("");
        })
        .catch((err) => {
          openErrorNotification(err.response.data.message);
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="onbdMain">
      <Header />
      <div className="onbdCont">
        <img src={bgGradient} alt="" className="grd" />
        <div className="whtCont">
          <div className="tpWht">
            <h4>Sign in</h4>
            <Link to="/facilitator/signup">
              <p>I don't have an account</p>
            </Link>
          </div>
          <form onSubmit={signin}>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email address"
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input.Password
              placeholder="Password"
              onChange={(e: any) => setPassword(e.target.value)}
            />
            <button>
              {!isLoading ? "Log in to Account" : <LoadingOutlined />}
            </button>
          </form>
          <Link to={"/forgot-password"}>
            <p className="fget">Forgot password?</p>
          </Link>
          <div className="tnc">
            <p>Terms and Condtions</p>
            <span>.</span>
            <p>Privacy Policy</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SigninFacilitator;
